export const USE_RESOURCE_START_MARK = 'USE_RESOURCE_START';
export const USE_RESOURCE_READY_MARK = 'USE_RESOURCE_READY';
export const BACKLOG_PREFETCHED_DATA_READY_MARK = 'BACKLOG_PREFETCHED_DATA_READY';
export const BACKLOG_ROOT_SPA_APP_START_MARK = 'BACKLOG_ROOT_SPA_APP_START';
export const BACKLOG = 'BACKLOG' as const;
export const ENABLED = 'ENABLED' as const;
export const DISABLED = 'DISABLED' as const;
export const ERROR_MESSAGE_BOARD_IS_LOCATIONLESS = 'Board is locationless';
export const PACKAGE_NAME = '@atlassian/jira-spa-apps-next-gen-backlog';
export const TEAM_NAME = 'A4T-Tanuki';
